import { warning } from 'motion-utils';
import { isGenerator } from '../generators/utils/is-generator.mjs';
import { isAnimatable } from './is-animatable.mjs';

function hasKeyframesChanged(keyframes) {
  var current = keyframes[0];
  if (keyframes.length === 1) return true;

  for (var i = 0; i < keyframes.length; i++) {
    if (keyframes[i] !== current) return true;
  }
}

function canAnimate(keyframes, name, type, velocity) {
  /**
   * Check if we're able to animate between the start and end keyframes,
   * and throw a warning if we're attempting to animate between one that's
   * animatable and another that isn't.
   */
  var originKeyframe = keyframes[0];
  if (originKeyframe === null) return false;
  /**
   * These aren't traditionally animatable but we do support them.
   * In future we could look into making this more generic or replacing
   * this function with mix() === mixImmediate
   */

  if (name === "display" || name === "visibility") return true;
  var targetKeyframe = keyframes[keyframes.length - 1];
  var isOriginAnimatable = isAnimatable(originKeyframe, name);
  var isTargetAnimatable = isAnimatable(targetKeyframe, name);
  warning(isOriginAnimatable === isTargetAnimatable, "You are trying to animate ".concat(name, " from \"").concat(originKeyframe, "\" to \"").concat(targetKeyframe, "\". ").concat(originKeyframe, " is not an animatable value - to enable this animation set ").concat(originKeyframe, " to a value animatable to ").concat(targetKeyframe, " via the `style` property.")); // Always skip if any of these are true

  if (!isOriginAnimatable || !isTargetAnimatable) {
    return false;
  }

  return hasKeyframesChanged(keyframes) || (type === "spring" || isGenerator(type)) && velocity;
}

export { canAnimate };